import Api from "@/services/api.service";

export default {
  create(object) {
    return Api().post("booking/create", object);
  },
  sourcePayment(object) {
    return Api().post("payment/source", object);
  },
  getBooking(filter) {
    return Api().get("booking/get", { params: filter });
  },
  getBookingById(id) {
    return Api().get(`booking/get/${id}`);
  },
  approvedBooking(object) {
    return Api().patch("booking/approved", object);
  },
  finishedBooking(object) {
    return Api().post("booking/finished", object);
  },
  rejectBooking(id, object) {
    return Api().put(`booking/delete/${id}`, object);
  },
  updateBooking(id, object) {
    return Api().put(`booking/edit/${id}`, object);
  },
  recurringBooking(id, object) {
    return Api().put(`booking/recurring/${id}`, object);
  },
  getBookingSlots(params) {
    return Api().get("booking/getSlots/", { params: params });
  }
};
